export const createNewsRepository = (appFetch) => {
    return {
        list(options = {}) {
            return appFetch.get('/api/v1/news', options);
        },
        latest(params = {}) {
            return appFetch.get('/api/v1/news/latest', {params});
        },
        details(slug, params = {}) {
            return appFetch.get(`/api/v1/news/${slug}`, {params});
        },
        user(token, params = {}) {
            return appFetch.get(`/api/v1/news-subscription/${token}`, {params});
        },
        subscribe(body, options = {}) {
            return appFetch.post('/api/v1/news-subscription', body, options);
        },
        unsubscribe(token, body, options = {}) {
            return appFetch.patch(`/api/v1/news-subscription/${token}`, body, options);
        },
    };
};
